export const isStatusError = (err: unknown): err is { status: number } => {
    return typeof err === "object" && err !== null && "status" in err && typeof err.status === "number";
};
